module.exports = __webpack_public_path__ + "img/centre-boulevard.5bab8a2d.webp";